import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLibModule } from '@nrwl/common-lib';
import { MonitorsPageWidgetComponent } from './components/monitors.page.widget/monitors.page.widget.component';
import { MonitorsEntityWidgetComponent } from './components/monitors.entity.widget/monitors.entity.widget.component';
import { MonitorsService } from './service/monitors.service';
import { CommonMaterialModule } from '@nrwl/common-material';
import { ViewTableModule } from '@nrwl/view-table';
import { ViewListModule } from '@nrwl/view-list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdvancedSearchModule } from '@nrwl/advanced-search';
import { ViaviTabulatorModule } from '../../../viavi-tabulator/src/index';
import { CommonMonitorTableComponent } from './components/common.monitor.table/common.monitor.table.component';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialModule,
    ViewTableModule,
    ViewListModule,
    FormsModule,
    ReactiveFormsModule,
    CommonLibModule,
    AdvancedSearchModule,
    ViaviTabulatorModule
  ],
  declarations: [
    MonitorsPageWidgetComponent,
    MonitorsEntityWidgetComponent,
    CommonMonitorTableComponent
  ],
  exports: [
    MonitorsPageWidgetComponent,
    MonitorsEntityWidgetComponent,
    CommonMonitorTableComponent
  ],
  providers: [MonitorsService]
})
export class MonitorManagementModule {}
